const RESEND_ECARD_FORM_NAME = 'resend-ecard-form';

class ResendEcardForm extends HTMLFormElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this._submitButton = this.querySelector('.button');

        this.addEventListener('submit', this._handleSubmitEvent);
    }

    disconnectedCallback() {
        this.removeEventListener('submit', this._handleSubmitEvent);
    }

    disable() {
        if (this._submitButton) {
            this._submitButton.disabled = true;
        }
    }

    _handleSubmitEvent(event) {
        event.preventDefault();

        this.disable();
        let confirmed = confirm('Are you sure you want to resend this Ecard');

        if (confirmed) {
            this._submitButton.innerText = 'Please wait';
            const el = document.createElement('input');
            el.type = 'hidden';
            el.name = 'CurrentUrl';
            el.value = location.pathname + location.search;
            this.appendChild(el);

            const otherForms = document.querySelectorAll(`form[is=${RESEND_ECARD_FORM_NAME}]`);
            [...otherForms].forEach((form) => form.disable());

            this.submit();
        } else {
            this._submitButton.disabled = false;
        }
    }
}

customElements.define(RESEND_ECARD_FORM_NAME, ResendEcardForm, { extends: 'form' });
